import axios from 'axios';
import { IOrderForEdit } from '../interfaces/order';
import { getOrdersByStatus, getOrderurl } from '../constants';

export const getOrders = (
  statuses: string,
  page: number,
  per_page: number,
  userId?: number,
  accord_order_state?: string,
  payment_status?: string,
  company_id?: string,
  date_from?: string,
  date_to?: string,
  hide_delivery_cost?: boolean,
  csv?: boolean,
  user_phone?: string | null,
  user_email?: string | null,
  user_name?: string | null,
  stock_status?: string
) => {
  const boxberry = company_id?.toString() === '-2';
  return axios.get(getOrdersByStatus(statuses), {
    params: {
      page,
      per_page,
      date_from,
      date_to,
      stock_status,
      payment_status,
      user_id: userId,
      user_email,
      user_phone,
      user_name,
      company_id: boxberry ? undefined : company_id,
      accord_order_state,
      hide_delivery_cost,
      csv,
      boxberry,
    },
  });
};

export const deleteOrder = (id: number) => axios.delete(getOrderurl(id));

export const editOrder = (id: number, order: IOrderForEdit) =>
  axios.put(getOrderurl(id), order);

export const getOrderById = (id: number) => axios.get(getOrderurl(id));

export function downloadOrderXlsx(id: number) {
  return axios.get(`/api/shop/order/${id}`, {
    params: { xlsx: true },
  });
}

export function downloadOrderItemsXlsx(id: number) {
  return axios.get(`/api/shop/order_xlsx/${id}`);
}

export function downloadOrdersItemsXlsx(id: number) {
  return axios.get(`/api/shop/orders_xlsx/${id}`);
}
